<template>
  <v-card v-if="event" class="custom-timetable-card">
    <v-card-text class="pa-0 ma-0">
      <div class="custom-timetable-card__top">
        <div class="d-flex align-start justify-space-between">
          <span>{{ event.tutor_name }}</span>
        </div>
      </div>

      <div class="custom-timetable-card__bot">
        <span class="time">{{ event.start_time }}-{{ event.end_time }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'TutorEventCard',
  props: {
    event: {
      type: Object,
      default: null,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep.custom-timetable-card {
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;

  & .custom-timetable-card__top {
    padding: 5px 10px;
    color: #ffffff;
    font-size: 0.75rem;
    line-height: 1.5;
    background: #50B71A;
  }

  & .custom-timetable-card__bot {
    color: var(--v-colorBlack-base);
    padding: 10px;
    background: #eeeeee;

    & > .time {
      font-size: 0.75rem;
      line-height: 1.5;
      font-weight: 600;
    }
  }
}
</style>
